// Ultra Fine Jewelry — concept imagery sources.
// NOTE: These are editorial concept images used until approved PiérrecDavís
// product photography is supplied. They must NEVER be presented as photographs
// of actual maison pieces. All category cards show "Concept Imagery" badges.

export const UFJ_IMAGES = {
  hero: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=2000&q=85",
  intro: "https://images.unsplash.com/photo-1596944924616-7b38e7cfac36?auto=format&fit=crop&w=1600&q=85",
  categories: {
    diamond_jewelry:  "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1200&q=85",
    high_rings:      "https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=1200&q=85",
    necklaces:       "https://images.unsplash.com/photo-1611085583191-a3b181a88401?auto=format&fit=crop&w=1200&q=85",
    bracelets:       "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?auto=format&fit=crop&w=1200&q=85",
    earrings:        "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=1200&q=85",
    gemstones:       "https://images.unsplash.com/photo-1550565118-3a14e8d0386f?auto=format&fit=crop&w=1200&q=85",
    one_of_a_kind:   "https://images.unsplash.com/photo-1588444837495-c6cfeb53f32d?auto=format&fit=crop&w=1200&q=85",
    bespoke:         "https://images.unsplash.com/photo-1543295204-2ae345412549?auto=format&fit=crop&w=1200&q=85",
  },
  editorial: "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?auto=format&fit=crop&w=1800&q=85",
  bespokeAtelier: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=1800&q=85",
};

export const UFJ_CATEGORIES = [
  {
    key: "diamond-jewelry",
    name: "Exceptional Diamond Jewelry",
    tagline: "Light held in architecture.",
    description:
      "Signature creations composed around diamonds of exceptional character — selected one by one for fire, proportion and quietude.",
    image: UFJ_IMAGES.categories.diamond_jewelry,
  },
  {
    key: "high-rings",
    name: "High Jewelry Rings",
    tagline: "Sculpted around a single stone.",
    description:
      "Rings conceived as miniature architecture — each setting designed to let its centerpiece speak alone.",
    image: UFJ_IMAGES.categories.high_rings,
  },
  {
    key: "necklaces",
    name: "Statement Necklaces",
    tagline: "A line drawn across the collarbone.",
    description:
      "Compositions in platinum and gold that trace the body with restraint — intended for occasions that will be remembered.",
    image: UFJ_IMAGES.categories.necklaces,
  },
  {
    key: "bracelets",
    name: "Diamond Bracelets",
    tagline: "Continuous light at the wrist.",
    description:
      "Articulated creations where every link is set by hand, calibrated to move as a single element of brilliance.",
    image: UFJ_IMAGES.categories.bracelets,
  },
  {
    key: "earrings",
    name: "Exceptional Earrings",
    tagline: "Framing without insistence.",
    description:
      "Pairs matched beyond identical — balanced in weight, in light return, and in the way they fall against the ear.",
    image: UFJ_IMAGES.categories.earrings,
  },
  {
    key: "gemstones",
    name: "Rare Gemstone Creations",
    tagline: "Colour, selected over time.",
    description:
      "Rubies, emeralds, sapphires and Paraíba tourmalines — gemstones acquired over seasons, set when the right form arrives.",
    image: UFJ_IMAGES.categories.gemstones,
  },
  {
    key: "one-of-a-kind",
    name: "One-of-a-Kind Creations",
    tagline: "Composed once. Never repeated.",
    description:
      "Pieces that will not re-enter the maison's inventory. Each is attributed, archived, and released to a single client.",
    image: UFJ_IMAGES.categories.one_of_a_kind,
  },
  {
    key: "bespoke",
    name: "Bespoke High Jewelry",
    tagline: "Composed privately, for one.",
    description:
      "A commissioned dialogue between client and atelier — from the choice of stone to the final signature in gold.",
    image: UFJ_IMAGES.categories.bespoke,
  },
];
